var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.PriceRenderer,{attrs:{"price":_setup.getPrice,"compareAtPrice":_setup.getCompareAtPrice,"quantity":_setup.props.quantity,"inverted":_setup.props.inverted}})
}
var staticRenderFns = []

export { render, staticRenderFns }